<p-confirmDialog></p-confirmDialog>

<p-table
  *ngIf="admins.length"
  [value]="admins"
  dataKey="id"
  (onSort)="onSort($event)"
  [autoLayout]="true"
  [customSort]="true"
  [responsive]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="text-center" style="width: 7rem" pSortableColumn="active">
        Status
        <p-sortIcon field="active"></p-sortIcon>
      </th>
      <th pSortableColumn="firstName">
        Name
        <p-sortIcon field="firstName"></p-sortIcon>
      </th>
      <th pSortableColumn="lastName">
        Surname
        <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="email">
        Email
        <p-sortIcon field="email"></p-sortIcon>
      </th>
      <th style="width: 4rem" *tjHasRole="'ADMIN_EDIT'">Edit</th>
      <th style="width: 4rem" *tjHasRole="'ADMIN_EDIT'">Delete</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-admin>
    <tr>
      <td class="text-center">
        <p-tag [rounded]="true" [severity]="admin.active ? 'success' : 'danger'">
          {{ admin.active ? 'Enabled' : 'Disabled' }}
        </p-tag>
      </td>
      <td>{{ admin.firstName || '-' }}</td>
      <td>{{ admin.lastName || '-' }}</td>
      <td>{{ admin.email || '-' }}</td>
      <td *tjHasRole="'ADMIN_EDIT'">
        <button
          pButton
          pRipple
          icon="pi pi-pencil"
          class="p-button-rounded p-button-success"
          pTooltip="Edit admin"
          (click)="onEdit(admin)"
        ></button>
      </td>
      <td *tjHasRole="'ADMIN_EDIT'">
        <button
          pButton
          pRipple
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger"
          pTooltip="Delete admin"
          (click)="onDelete(admin)"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="text-center p-4">
        <div class="flex flex-column align-items-center">
          <i class="pi pi-users text-4xl text-gray-400 mb-2"></i>
          <span class="text-gray-500">No admins found</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
